import type { PlainDate } from "@sa-nu/shared-utils/date";

export function computeAvailabilityStripRange(
  rangeStart: PlainDate,
  deltaNights: number,
): PlainDate {
  return rangeStart.add({ days: deltaNights });
}
